"use strict";

exports.__esModule = true;
var index_1 = require("./index");
function getConfigKey(keys) {
  return process.env.ATATUS_CONFIG_KEY || keys[index_1.endpoints.rootDomain];
}
function atatusChecker(f) {
  if (global && global.window && global.window.atatus) {
    return f;
  }
  return function () {};
}
exports.config = atatusChecker(function (keys, settings) {
  if (settings === void 0) {
    settings = {};
  }
  global.window.atatus.config(getConfigKey(keys), settings).install();
});
exports.setVersion = atatusChecker(function (version) {
  if (version === void 0) {
    version = '0.0.0';
  }
  global.window.atatus.setVersion(process.env.ATATUS_VERSION_NUMBER || version);
});
exports.enableOffline = atatusChecker(function (shouldEnable) {
  global.window.atatus.enableOffline(shouldEnable);
});
exports.setUser = atatusChecker(function (userId) {
  global.window.atatus.setUser(userId);
});
exports.setCustomData = atatusChecker(function (userData) {
  global.window.atatus.setCustomData(userData);
});
exports.setTags = atatusChecker(function (tags) {
  global.window.atatus.setTags(tags);
});
exports.setAllowedDomains = atatusChecker(function (domains) {
  global.window.atatus.setAllowedDomains(domains);
});
exports.notify = atatusChecker(function () {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var _a;
  (_a = global.window.atatus).notify.apply(_a, args);
});
exports.onBeforeErrorSend = atatusChecker(function () {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var _a;
  (_a = global.window.atatus).onBeforeErrorSend.apply(_a, args);
});
exports.beginTransaction = atatusChecker(function (transactionKeyName) {
  global.window.atatus.beginTransaction(transactionKeyName);
});
exports.endTransaction = atatusChecker(function (transactionKeyName) {
  global.window.atatus.endTransaction(transactionKeyName);
});
exports.failTransaction = atatusChecker(function (transactionKeyName) {
  global.window.atatus.failTransaction(transactionKeyName);
});
exports.cancelTransaction = atatusChecker(function (transactionKeyName) {
  global.window.atatus.cancelTransaction(transactionKeyName);
});